import React from 'react';
import { observer } from 'mobx-react';
import { observable, computed } from 'mobx';
import { RouteStore, WorksheetStore } from '@seedlang/stores';
import { isBlank } from '@seedlang/utils';
import Alert from 'components/alert';
import styled from '@emotion/styled';
import { AppUI } from '@seedlang/state';
import CreateWithTitle from 'components/creator/create_with_title';

const WarningMessage = styled(Alert)`
  font-size: 12px;
  padding: 2px;
  background: #f2dede;
  color: black;
  margin-top: 5px;
`;

@observer
class WorksheetCreate extends React.Component {
  @observable name = '';
  @observable showWarning = false;

  @computed get warningMessage() {
    if (!AppUI.siteIsDefault && this.name && this.name.match(new RegExp(`${AppUI.site.teamName}\\s*\\d+`, 'i'))) {
      const episodeCode = `${this.name?.match('Super') ? 'S' : ''}${AppUI.site.teamInitials} ${this.name?.match(/\d+/)?.[0] || '93'}`;
      return `Use this format for episode names to keep post names concise: "(${episodeCode})". This episode code will be displayed in post tags and will be searchable.`;
    }
    return null;
  }

  onChange = value => {
    this.name = value;
    this.showWarning = !isBlank(this.warningMessage);
  };

  onCreate = name => {
    WorksheetStore.create(
      {
        data: {
          name,
          group_id: this.props.groupId,
        },
      },
      this.afterCreate,
    );
    this.name = '';
    this.showWarning = false;
  };

  afterCreate = resp => {
    RouteStore.routeToNamed('creator.worksheets.edit', {groupId: this.props.groupId, worksheetId: resp.id});
  };

  render() {
    return (
      <>
        <CreateWithTitle
          onChange={this.onChange}
          placeholder='Enter Post Name'
          onCreate={this.onCreate}
        />
        {this.showWarning && <WarningMessage>{this.warningMessage}</WarningMessage>}
      </>
    );
  }
}

export default WorksheetCreate;
